/* global axios */
import ApiClient from './ApiClient';

const buildParams = params =>
  new URLSearchParams(
    Object.entries(params).filter(
      ([, value]) => value !== undefined && value !== ''
    )
  ).toString();

class DealsApiClient extends ApiClient {
  constructor() {
    super('deals', { accountScoped: true });
  }

  get(params = {}) {
    const {
      page = 1,
      sort = '-created_at',
      search,
      pipeline_id,
      per_page: perPage,
      contact_id: contactId,
      company_id: companyId,
    } = params;
    const requestURL = `${this.url}?${buildParams({ page, sort, search, pipeline_id, per_page: perPage, contact_id: contactId, company_id: companyId })}`;
    return axios.get(requestURL);
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(dealData) {
    return axios.post(this.url, { deal: dealData });
  }

  update(id, dealData) {
    return axios.patch(`${this.url}/${id}`, { deal: dealData });
  }

  destroy(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  importDeals({ file, fieldMapping }) {
    const formData = new FormData();
    formData.append('import_file', file);
    if (fieldMapping && Object.keys(fieldMapping).length) {
      formData.append('field_mapping', JSON.stringify(fieldMapping));
    }
    return axios.post(`${this.url}/import`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  importStatus() {
    return axios.get(`${this.url}/import_status`);
  }

  exportDeals(ids) {
    return axios.post(`${this.url}/export`, { ids }, { responseType: 'blob' });
  }
}

export default new DealsApiClient();
